'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { usePathname } from 'next/navigation'
import { ViewTransition, type ReactNode } from 'react'

/**
 * The crossfade between pages: one `<ViewTransition>` boundary per pathname.
 *
 * **Why a boundary per page and not one for all of them.** A single boundary around `children`
 * is "updated" on every navigation, and React then puts the same generated name — `_t_0_`,
 * `_t_0__1`, … — on the outgoing page's first elements and on the incoming page's. The browser
 * takes a shared name as "the same element, moved" and animates the old box into the new one. On
 * the pages that share the site shell that is harmless, because the first element is the skip
 * link on both sides and its box never changes. The sign-up page has no shell, so its first
 * element is the page itself, and the browser grew the skip link's 169×36 box, parked above the
 * viewport, into the whole window: a zoom, on every visit to the form, and again on the way out.
 *
 * Keying the boundary by pathname makes a navigation an unmount and a mount instead of an update.
 * The outgoing page exits under its own name and the incoming page enters under another, nothing
 * is paired, and each side only fades, in place. The name is given explicitly rather than left to
 * React because a generated one is unique per boundary *position*, which is the pairing this
 * exists to prevent; it is derived from the pathname because that is what makes two pages
 * different. `view-transition-name` is a CSS identifier, so the slashes go.
 *
 * `globals.css` sets the duration for every group this creates and switches the animation off
 * under `prefers-reduced-motion: reduce`; `e2e/view-transitions.spec.ts` holds both, and the
 * absence of any group that moves or resizes.
 */
export function PageTransition({ children }: { children: ReactNode }) {
  const pathname = usePathname()
  const name = `page-${pathname.replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/^-+|-+$/g, '') || 'root'}`

  return (
    <ViewTransition key={name} name={name}>
      {children}
    </ViewTransition>
  )
}
